var cov_2fmk02mms8 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Datum/hoc.tsx",
      hash = "4ef07c7536c6e42da6e9216a7be9e881d2d441d8",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Datum/hoc.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 14
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "1": {
        start: {
          line: 16,
          column: 100
        },
        end: {
          line: 16,
          column: 113
        }
      },
      "2": {
        start: {
          line: 17,
          column: 16
        },
        end: {
          line: 17,
          column: 27
        }
      },
      "3": {
        start: {
          line: 18,
          column: 20
        },
        end: {
          line: 18,
          column: 64
        }
      },
      "4": {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 94,
          column: 3
        }
      },
      "5": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 30,
          column: 18
        }
      },
      "6": {
        start: {
          line: 31,
          column: 48
        },
        end: {
          line: 31,
          column: 53
        }
      },
      "7": {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 50,
          column: 7
        }
      },
      "8": {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 26
        }
      },
      "9": {
        start: {
          line: 36,
          column: 20
        },
        end: {
          line: 42,
          column: 9
        }
      },
      "10": {
        start: {
          line: 38,
          column: 12
        },
        end: {
          line: 38,
          column: 53
        }
      },
      "11": {
        start: {
          line: 39,
          column: 12
        },
        end: {
          line: 39,
          column: 20
        }
      },
      "12": {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 45,
          column: 9
        }
      },
      "13": {
        start: {
          line: 44,
          column: 10
        },
        end: {
          line: 44,
          column: 57
        }
      },
      "14": {
        start: {
          line: 46,
          column: 8
        },
        end: {
          line: 48,
          column: 9
        }
      },
      "15": {
        start: {
          line: 47,
          column: 10
        },
        end: {
          line: 47,
          column: 105
        }
      },
      "16": {
        start: {
          line: 49,
          column: 8
        },
        end: {
          line: 49,
          column: 66
        }
      },
      "17": {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 54,
          column: 7
        }
      },
      "18": {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 53,
          column: 38
        }
      },
      "19": {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 58,
          column: 31
        }
      },
      "20": {
        start: {
          line: 59,
          column: 6
        },
        end: {
          line: 59,
          column: 65
        }
      },
      "21": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 64,
          column: 31
        }
      },
      "22": {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 67,
          column: 7
        }
      },
      "23": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 66,
          column: 49
        }
      },
      "24": {
        start: {
          line: 71,
          column: 21
        },
        end: {
          line: 71,
          column: 62
        }
      },
      "25": {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 72,
          column: 57
        }
      },
      "26": {
        start: {
          line: 72,
          column: 51
        },
        end: {
          line: 72,
          column: 57
        }
      },
      "27": {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 73,
          column: 36
        }
      },
      "28": {
        start: {
          line: 77,
          column: 40
        },
        end: {
          line: 77,
          column: 50
        }
      },
      "29": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 46
        }
      },
      "30": {
        start: {
          line: 78,
          column: 23
        },
        end: {
          line: 78,
          column: 46
        }
      },
      "31": {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 81,
          column: 7
        }
      },
      "32": {
        start: {
          line: 80,
          column: 8
        },
        end: {
          line: 80,
          column: 46
        }
      },
      "33": {
        start: {
          line: 82,
          column: 21
        },
        end: {
          line: 82,
          column: 62
        }
      },
      "34": {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 87,
          column: 7
        }
      },
      "35": {
        start: {
          line: 84,
          column: 8
        },
        end: {
          line: 84,
          column: 76
        }
      },
      "36": {
        start: {
          line: 85,
          column: 8
        },
        end: {
          line: 85,
          column: 32
        }
      },
      "37": {
        start: {
          line: 86,
          column: 8
        },
        end: {
          line: 86,
          column: 32
        }
      },
      "38": {
        start: {
          line: 89,
          column: 6
        },
        end: {
          line: 89,
          column: 59
        }
      },
      "39": {
        start: {
          line: 89,
          column: 27
        },
        end: {
          line: 89,
          column: 59
        }
      },
      "40": {
        start: {
          line: 92,
          column: 6
        },
        end: {
          line: 92,
          column: 58
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 23
          }
        },
        loc: {
          start: {
            line: 15,
            column: 112
          },
          end: {
            line: 95,
            column: 1
          }
        },
        line: 15
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 29,
            column: 5
          }
        },
        loc: {
          start: {
            line: 29,
            column: 41
          },
          end: {
            line: 55,
            column: 5
          }
        },
        line: 29
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 37,
            column: 10
          },
          end: {
            line: 37,
            column: 11
          }
        },
        loc: {
          start: {
            line: 37,
            column: 25
          },
          end: {
            line: 40,
            column: 11
          }
        },
        line: 37
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        },
        loc: {
          start: {
            line: 57,
            column: 24
          },
          end: {
            line: 60,
            column: 5
          }
        },
        line: 57
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        },
        loc: {
          start: {
            line: 62,
            column: 52
          },
          end: {
            line: 68,
            column: 5
          }
        },
        line: 62
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        },
        loc: {
          start: {
            line: 70,
            column: 25
          },
          end: {
            line: 74,
            column: 5
          }
        },
        line: 70
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 76,
            column: 5
          }
        },
        loc: {
          start: {
            line: 76,
            column: 13
          },
          end: {
            line: 93,
            column: 5
          }
        },
        line: 76
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 16,
            column: 10
          },
          end: {
            line: 16,
            column: 23
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 16,
            column: 17
          },
          end: {
            line: 16,
            column: 23
          }
        }],
        line: 16
      },
      "1": {
        loc: {
          start: {
            line: 16,
            column: 25
          },
          end: {
            line: 16,
            column: 38
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 16,
            column: 31
          },
          end: {
            line: 16,
            column: 38
          }
        }],
        line: 16
      },
      "2": {
        loc: {
          start: {
            line: 16,
            column: 40
          },
          end: {
            line: 16,
            column: 49
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 16,
            column: 48
          },
          end: {
            line: 16,
            column: 49
          }
        }],
        line: 16
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 51
          },
          end: {
            line: 16,
            column: 65
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 16,
            column: 63
          },
          end: {
            line: 16,
            column: 65
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 16,
            column: 84
          },
          end: {
            line: 16,
            column: 95
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 16,
            column: 91
          },
          end: {
            line: 16,
            column: 95
          }
        }],
        line: 16
      },
      "5": {
        loc: {
          start: {
            line: 16,
            column: 100
          },
          end: {
            line: 16,
            column: 113
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 100
          },
          end: {
            line: 16,
            column: 107
          }
        }, {
          start: {
            line: 16,
            column: 111
          },
          end: {
            line: 16,
            column: 113
          }
        }],
        line: 16
      },
      "6": {
        loc: {
          start: {
            line: 18,
            column: 20
          },
          end: {
            line: 18,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 18,
            column: 27
          },
          end: {
            line: 18,
            column: 46
          }
        }, {
          start: {
            line: 18,
            column: 49
          },
          end: {
            line: 18,
            column: 64
          }
        }],
        line: 18
      },
      "7": {
        loc: {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 50,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 50,
            column: 7
          }
        }, {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 50,
            column: 7
          }
        }],
        line: 33
      },
      "8": {
        loc: {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 45,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 45,
            column: 9
          }
        }, {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 45,
            column: 9
          }
        }],
        line: 43
      },
      "9": {
        loc: {
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 48,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 48,
            column: 9
          }
        }, {
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 48,
            column: 9
          }
        }],
        line: 46
      },
      "10": {
        loc: {
          start: {
            line: 52,
            column: 6
          },
          end: {
            line: 54,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 6
          },
          end: {
            line: 54,
            column: 7
          }
        }, {
          start: {
            line: 52,
            column: 6
          },
          end: {
            line: 54,
            column: 7
          }
        }],
        line: 52
      },
      "11": {
        loc: {
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 67,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 67,
            column: 7
          }
        }, {
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 67,
            column: 7
          }
        }],
        line: 65
      },
      "12": {
        loc: {
          start: {
            line: 72,
            column: 6
          },
          end: {
            line: 72,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 72,
            column: 6
          },
          end: {
            line: 72,
            column: 57
          }
        }, {
          start: {
            line: 72,
            column: 6
          },
          end: {
            line: 72,
            column: 57
          }
        }],
        line: 72
      },
      "13": {
        loc: {
          start: {
            line: 72,
            column: 10
          },
          end: {
            line: 72,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 72,
            column: 10
          },
          end: {
            line: 72,
            column: 25
          }
        }, {
          start: {
            line: 72,
            column: 29
          },
          end: {
            line: 72,
            column: 49
          }
        }],
        line: 72
      },
      "14": {
        loc: {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 46
          }
        }, {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 46
          }
        }],
        line: 78
      },
      "15": {
        loc: {
          start: {
            line: 79,
            column: 6
          },
          end: {
            line: 81,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 79,
            column: 6
          },
          end: {
            line: 81,
            column: 7
          }
        }, {
          start: {
            line: 79,
            column: 6
          },
          end: {
            line: 81,
            column: 7
          }
        }],
        line: 79
      },
      "16": {
        loc: {
          start: {
            line: 83,
            column: 6
          },
          end: {
            line: 87,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 6
          },
          end: {
            line: 87,
            column: 7
          }
        }, {
          start: {
            line: 83,
            column: 6
          },
          end: {
            line: 87,
            column: 7
          }
        }],
        line: 83
      },
      "17": {
        loc: {
          start: {
            line: 83,
            column: 10
          },
          end: {
            line: 83,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 83,
            column: 10
          },
          end: {
            line: 83,
            column: 25
          }
        }, {
          start: {
            line: 83,
            column: 29
          },
          end: {
            line: 83,
            column: 55
          }
        }],
        line: 83
      },
      "18": {
        loc: {
          start: {
            line: 84,
            column: 22
          },
          end: {
            line: 84,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 84,
            column: 48
          },
          end: {
            line: 84,
            column: 57
          }
        }, {
          start: {
            line: 84,
            column: 60
          },
          end: {
            line: 84,
            column: 75
          }
        }],
        line: 84
      },
      "19": {
        loc: {
          start: {
            line: 89,
            column: 6
          },
          end: {
            line: 89,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 89,
            column: 6
          },
          end: {
            line: 89,
            column: 59
          }
        }, {
          start: {
            line: 89,
            column: 6
          },
          end: {
            line: 89,
            column: 59
          }
        }],
        line: 89
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Datum/hoc.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { curry } from '../utils/func';
import { capitalize } from '../utils/strings';
import { IGNORE_VALIDATE, WITH_OUT_DISPATCH } from './types';
import List from './List';
import Form from './Form';
var types = (cov_2fmk02mms8.s[0]++, {
  form: Form,
  list: List
});
export default curry(function (options, Origin) {
  var _class, _temp;

  cov_2fmk02mms8.f[0]++;

  var _ref = (cov_2fmk02mms8.s[1]++, (cov_2fmk02mms8.b[5][0]++, options) || (cov_2fmk02mms8.b[5][1]++, {})),
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? (cov_2fmk02mms8.b[0][0]++, 'list') : _ref$type,
      _ref$key = _ref.key,
      key = _ref$key === void 0 ? (cov_2fmk02mms8.b[1][0]++, 'value') : _ref$key,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? (cov_2fmk02mms8.b[2][0]++, 0) : _ref$limit,
      _ref$bindProps = _ref.bindProps,
      bindProps = _ref$bindProps === void 0 ? (cov_2fmk02mms8.b[3][0]++, []) : _ref$bindProps,
      ignoreUndefined = _ref.ignoreUndefined,
      _ref$pure = _ref.pure,
      pure = _ref$pure === void 0 ? (cov_2fmk02mms8.b[4][0]++, true) : _ref$pure;

  var Datum = (cov_2fmk02mms8.s[2]++, types[type]);
  var Component = (cov_2fmk02mms8.s[3]++, pure ? (cov_2fmk02mms8.b[6][0]++, React.PureComponent) : (cov_2fmk02mms8.b[6][1]++, React.Component));
  cov_2fmk02mms8.s[4]++;
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(_class, _Component);

    var _super = _createSuper2(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      cov_2fmk02mms8.f[1]++;
      cov_2fmk02mms8.s[5]++;
      _this = _super.call(this, props);
      _this.datum = void 0;
      _this.prevValues = void 0;

      var _ref2 = (cov_2fmk02mms8.s[6]++, props),
          datum = _ref2.datum,
          onChange = _ref2.onChange,
          initValidate = _ref2.initValidate;

      cov_2fmk02mms8.s[7]++;

      if (datum instanceof Datum) {
        cov_2fmk02mms8.b[7][0]++;
        cov_2fmk02mms8.s[8]++;
        _this.datum = datum;
      } else {
        cov_2fmk02mms8.b[7][1]++;
        var ops = (cov_2fmk02mms8.s[9]++, bindProps.reduce(function (o, k) {
          cov_2fmk02mms8.f[2]++;
          cov_2fmk02mms8.s[10]++;
          o[k] = props[k];
          cov_2fmk02mms8.s[11]++;
          return o;
        }, {
          limit: limit,
          initValidate: initValidate
        }));
        cov_2fmk02mms8.s[12]++;

        if (key in props) {
          cov_2fmk02mms8.b[8][0]++;
          cov_2fmk02mms8.s[13]++;
          ops[key] = props[key];
        } else {
          cov_2fmk02mms8.b[8][1]++;
        }

        cov_2fmk02mms8.s[14]++;

        if ("default".concat(capitalize(key)) in props) {
          cov_2fmk02mms8.b[9][0]++;
          cov_2fmk02mms8.s[15]++;
          ops["default".concat(capitalize(key))] = props["default".concat(capitalize(key))];
        } else {
          cov_2fmk02mms8.b[9][1]++;
        }

        cov_2fmk02mms8.s[16]++;
        _this.datum = new Datum(Object.assign(ops, datum));
      }

      cov_2fmk02mms8.s[17]++;

      if (onChange) {
        cov_2fmk02mms8.b[10][0]++;
        cov_2fmk02mms8.s[18]++;
        _this.datum.onChange = onChange;
      } else {
        cov_2fmk02mms8.b[10][1]++;
      }

      return _this;
    }

    _createClass(_class, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        cov_2fmk02mms8.f[3]++;
        cov_2fmk02mms8.s[19]++;
        this.datum.setLock(false);
        cov_2fmk02mms8.s[20]++;
        this.prevValues = this.props[key];
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        cov_2fmk02mms8.f[4]++;
        cov_2fmk02mms8.s[21]++;
        // update datum.onchange
        this.datum.setLock(false);
        cov_2fmk02mms8.s[22]++;

        if (prevProps.onChange !== this.props.onChange) {
          cov_2fmk02mms8.b[11][0]++;
          cov_2fmk02mms8.s[23]++;
          this.datum.onChange = this.props.onChange;
        } else {
          cov_2fmk02mms8.b[11][1]++;
        }
      }
    }, {
      key: "setValue",
      value: function setValue(t) {
        cov_2fmk02mms8.f[5]++;
        var values = (cov_2fmk02mms8.s[24]++, this.props[key]);
        cov_2fmk02mms8.s[25]++;

        if ((cov_2fmk02mms8.b[13][0]++, ignoreUndefined) && (cov_2fmk02mms8.b[13][1]++, values === undefined)) {
          cov_2fmk02mms8.b[12][0]++;
          cov_2fmk02mms8.s[26]++;
          return;
        } else {
          cov_2fmk02mms8.b[12][1]++;
        }

        cov_2fmk02mms8.s[27]++;
        this.datum.setValue(values, t);
      }
    }, {
      key: "render",
      value: function render() {
        cov_2fmk02mms8.f[6]++;

        var _ref3 = (cov_2fmk02mms8.s[28]++, this.props),
            onDatumBind = _ref3.onDatumBind,
            props = _objectWithoutProperties(_ref3, ["onDatumBind"]);

        cov_2fmk02mms8.s[29]++;

        if (onDatumBind) {
          cov_2fmk02mms8.b[14][0]++;
          cov_2fmk02mms8.s[30]++;
          onDatumBind(this.datum);
        } else {
          cov_2fmk02mms8.b[14][1]++;
        }

        cov_2fmk02mms8.s[31]++;

        if (bindProps.includes('disabled')) {
          cov_2fmk02mms8.b[15][0]++;
          cov_2fmk02mms8.s[32]++;
          this.datum.setDisabled(props.disabled);
        } else {
          cov_2fmk02mms8.b[15][1]++;
        }

        var values = (cov_2fmk02mms8.s[33]++, this.props[key]);
        cov_2fmk02mms8.s[34]++;

        if ((cov_2fmk02mms8.b[17][0]++, type === 'form') && (cov_2fmk02mms8.b[17][1]++, values !== this.prevValues)) {
          cov_2fmk02mms8.b[16][0]++;
          cov_2fmk02mms8.s[35]++;
          this.setValue(this.props.initValidate ? (cov_2fmk02mms8.b[18][0]++, undefined) : (cov_2fmk02mms8.b[18][1]++, IGNORE_VALIDATE));
          cov_2fmk02mms8.s[36]++;
          this.datum.setLock(true);
          cov_2fmk02mms8.s[37]++;
          this.prevValues = values;
        } else {
          cov_2fmk02mms8.b[16][1]++;
        }

        cov_2fmk02mms8.s[38]++;

        if (type === 'list') {
          cov_2fmk02mms8.b[19][0]++;
          cov_2fmk02mms8.s[39]++;
          this.setValue(WITH_OUT_DISPATCH);
        } else {
          cov_2fmk02mms8.b[19][1]++;
        } // delete props[key]


        cov_2fmk02mms8.s[40]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, {
            datum: this.datum,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 92,
              columnNumber: 14
            }
          }))
        );
      }
    }]);

    return _class;
  }(Component), _class.defaultProps = {
    initValidate: false
  }, _temp;
});